export default __webpack_public_path__ + "static/media/demo_logo.435cf551.png";